import React from 'react'
import './index.scss'
import { useSearchParams } from 'react-router-dom'

const Spinner = () => {
  const [searchParams] = useSearchParams()
  const isRokuBox = searchParams.get('device') === 'roku_box' || !!sessionStorage.getItem('isRokuBox');
  const brandLoader = window?.app_data?.appcmsPlatform?.images?.desktopLoader;
  // return <div className="spinner site-color"></div>  
  return <div id='brand-loader' style={isRokuBox ? { background: '#000' } : {}}><img src={brandLoader} role="presentation"/></div>
}

export default Spinner